import { render, staticRenderFns } from "./ReportsContainerOrganic.vue?vue&type=template&id=14289d9a&"
import script from "./ReportsContainerOrganic.vue?vue&type=script&lang=js&"
export * from "./ReportsContainerOrganic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports